export class UserInfoViewModel {
    userId = 0;
    userName = '';
    roleId = 0;
    roleName = '';
    accessLevel = '';
    branchId = 0;

    token = "";
}